import React, { Component } from 'react';
import PropTypes from 'prop-types';
import InternalRepatriationsTransactionsCreateDialog from './InternalRepatriationsTransactionsCreateDialog';

class InternalRepatriationsTransactionsCreate extends Component {
  render() {
    return (
      <div>
        <InternalRepatriationsTransactionsCreateDialog
          row={this.props}
          closeDialog={this.props.closeDialog}
          openDialog={this.props.openDialog}
          refreshTransactions={this.props.refreshTransactions}
        />
      </div>
    );
  }
}

InternalRepatriationsTransactionsCreate.propTypes = {
  closeDialog: PropTypes.func.isRequired,
  openDialog: PropTypes.func.isRequired,
  refreshTransactions: PropTypes.func,
};

export default InternalRepatriationsTransactionsCreate;
